import { eraseCookie } from "../function";

const unauthService =()=> {
  eraseCookie('token')
  eraseCookie('id')
  eraseCookie('role')
  window.location.reload();
}
export default unauthService;